<template>
  <div class="login-wrap">
    <div class="login-card">
      <div class="login-logo">
        <img src="../assets/aslogo.png" alt="logo">
      </div>
      <h1 class="login-title">Welcome back</h1>
      <p class="login-subtitle">Sign in to continue</p>

      <b-form @submit="onSubmit">
        <b-form-group id="input-group-1" label="Username" label-for="input-1">
          <b-form-input
            id="input-1"
            v-model="form.username"
            type="text"
            size="lg"
            required
            autocomplete="username"
            placeholder="Username"
          ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-2" label="Password" label-for="input-2">
          <b-form-input
            id="input-2"
            v-model="form.password"
            type="password"
            size="lg"
            required
            autocomplete="current-password"
            placeholder="Password"
          ></b-form-input>
        </b-form-group>

        <b-button block size="lg" type="submit" variant="primary" class="login-btn">
          <b-icon-unlock class="mr-2"></b-icon-unlock> Sign in
        </b-button>
      </b-form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import fixed from '../fixed';

export default {
  data() {
    return {
      form: {
        username: '',
        password: '',
      },
    };
  },
  async mounted() {
    try {
      await axios.get(`${fixed.API_URL}/authenticated`, { withCredentials: true });
      await this.$router.push('/');
    } catch (error) {
      this.$toast.info('Please use your credentials to log in');
    }
  },
  methods: {
    async onSubmit(evt) {
      evt.preventDefault();
      const formData = new FormData();
      formData.set('username', this.form.username);
      formData.set('password', this.form.password);
      try {
        const resp = await axios.post(fixed.BASE_URL, formData, { withCredentials: true });
        if (resp.status === 200) {
          localStorage.setItem('user', JSON.stringify(resp.data));
          window.location.reload();
        }
      } catch (error) {
        this.$toast.error(error?.response?.data);
      }
    },
  },
};
</script>

<style>
.login-wrap {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background:
    radial-gradient(60% 50% at 50% 0%, rgba(10, 132, 255, 0.14), transparent 70%),
    radial-gradient(40% 40% at 85% 100%, rgba(139, 92, 246, 0.1), transparent 70%);
}

.login-card {
  width: 100%;
  max-width: 380px;
  padding: 2.5rem 2rem 2rem;
  background-color: var(--surface);
  border: 1px solid var(--border-strong);
  border-radius: 20px;
  box-shadow: var(--shadow-lg);
}

.login-logo {
  display: flex;
  justify-content: center;
  margin-bottom: 1.25rem;
}

.login-logo img {
  width: 84px;
  padding: 0.9rem;
  background: linear-gradient(160deg, var(--surface-3), var(--surface));
  border: 1px solid var(--border-strong);
  border-radius: 22px;
  box-shadow: var(--shadow);
}

.login-title {
  text-align: center;
  font-size: 1.5rem;
  letter-spacing: -0.025em;
  margin-bottom: 0.25rem;
}

.login-subtitle {
  text-align: center;
  color: var(--text-muted);
  margin-bottom: 1.75rem;
  font-size: 0.9rem;
}

.login-btn {
  margin-top: 0.75rem;
}
</style>
